    'use strict';
    import { Inject, Injectable } from 'ng-metadata/core';

    import {getVid} from '../appConfig/appConfigForward';

    const replace = require('lodash/replace');

    @Injectable()
    export class ImagesUtil{
        private vid:string= getVid();


        /* private members */
        private configuration:any;

        constructor(@Inject('$location') private $location: ng.ILocationService,
            @Inject('$translate') private $translate: ng.translate.ITranslateService,
            @Inject('$q')        private $q:ng.IQService) {
        }

        public getImageLink(link){
            return this.$q((resolve, reject)=> {
                if (link && link.linkURL) {
                    let successLink = link.linkURL;
                    let image = new Image();

                    image.onload = ()=> {// jshint ignore:line
                        if (image.width > 1) {//amazon return 1x1 pixel sometimes
                            resolve(link);//we have the link - success
                        } else {
                            reject('');
                        }
                    };
                    image.onerror =  ()=> {// jshint ignore:line
                        reject('');
                    };
                     
                    image.src = this.handleLink(successLink);
                } else {
                    reject('');
                }
            });

        }
        
        public handleLink(link) {
            let newLink = link;
            let protocol = 'https';
            try {
                let l = this.$location as any;
                protocol = l.$$protocol;
            }catch(err){
                protocol = 'https';
            }
            if(protocol === 'https'){
                newLink = replace(link, 'http://', 'https://');
            }
            return newLink;
        }

}




// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/ImagesUtil.service.ts